import { render, staticRenderFns } from "./new-default.vue?vue&type=template&id=4d809fb7&"
import script from "./new-default.vue?vue&type=script&lang=js&"
export * from "./new-default.vue?vue&type=script&lang=js&"
import style0 from "./new-default.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports